var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicSectionDividerVar = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@wheelroom/core");
exports.TopicSectionDividerVar = (props) => {
    const sectionWheel = core_1.getSectionWheel({
        themeId: props.theme || props.activeThemeId,
        wheelId: 'topicSection',
        sectionWheels: props.sectionWheels,
        variation: 'divider',
    });
    if (!sectionWheel) {
        return null;
    }
    const { wheel } = sectionWheel;
    return react_1.default.createElement(core_1.Hr, { wheel: wheel });
};
//# sourceMappingURL=topic-section-divider-var.js.map